<template>
    <v-card elevation="3" class="rounded-lg" flat>
      <v-card-text>
        <v-row>
          <v-col cols="4" md="6">
            <span class="font-weight-bold"> {{ this.sample.soilArea.name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <!-- Sub samples -->
          <v-col cols="2">
            <v-row class="mb-0">
              <v-col cols="12">
                <v-icon>mdi-qrcode</v-icon>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <span>{{ qty_photos }}</span>
              </v-col>
              <v-col>
                <v-img
                  max-width="17"
                  max-height="17"
                  :src="require('@/assets/img/flag_target.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-col>
          <!-- Codes and dates -->
          <v-col cols="5">
            <v-row>
              <span
                v-if="status != 'NOT_STARTED' && status != 'IN_PROGRESS'"
                class="py-0 sample--code"
              >
                {{ code }}
              </span>
              <span v-else class="sample--empty-info mt-0">
                - - - - - - - - - - - - -
              </span>
            </v-row>
            <v-row color="warning">
              <span v-if="status != 'NOT_STARTED'" class="sample--date">
                {{ fecha }}
              </span>
              <span v-else class="sample--empty-info mb-2">
                - - - - - - - - - - -
              </span>
            </v-row>
            <v-row>
              <span
                v-if="status != 'NOT_STARTED' && status != 'IN_PROGRESS'"
                class="py-1 sample--kit"
              >
                <!-- <div v-if="typeof sample.kit == 'undefined'">Sin registro</div> -->
                <div>
                  {{ folioAnalysis }}
                  {{ tracingStatus }}
                </div>
              </span>
              <span v-else class="sample--empty-info mt-2">
                - - - - - - - - - - - - -
              </span>
            </v-row>
          </v-col>
          <!-- status -->
          <v-col cols="5">
            <!-- <v-row v-if="status == 'NOT_STARTED'" justify="center" align="center">
              <v-icon color="secondary" size="22">mdi-close</v-icon>
              <v-img
                max-width="20"
                max-height="20"
                :src="require('@/assets/img/flag_target.png')"
              ></v-img>
            </v-row> -->
            <v-row
              v-if="status == 'IN_PROGRESS'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-timer-sand</v-icon>
              <span class="secondary--text mx-1">{{
                translations.label_sampling_in_progress
              }}</span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'VALIDATED'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-check</v-icon>
              <span class="secondary--text mr-1">{{
                translations.label_sampling_finished
              }}</span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'SENT'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-truck-delivery</v-icon>
              <span class="secondary--text mx-2">
                {{ translations.label_sent }}
              </span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                value="true"
                checked
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'RECEIVED'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-check-all</v-icon>
              <span class="secondary--text mx-2">
                {{ translations.label_received }}
              </span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'MEASURING'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-timer-sand</v-icon>
              <span class="secondary--text mr-1">{{
                translations.label_measuring
              }}</span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'MEASURED'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-chart-line-variant</v-icon>
              <span class="secondary--text mr-1">{{
                translations.label_measured
              }}</span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'VALUATING'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-timer-sand</v-icon>
              <span class="secondary--text mx-1"
                >{{ translations.label_valuating }}
              </span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-else-if="status == 'VALUATED'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <v-icon color="secondary" size="17">mdi-chart-line-variant</v-icon>
              <span class="secondary--text mx-1"
                >{{ translations.label_valuated }}
              </span>
              <input
                v-if="sendAvailable"
                type="checkbox"
                style="height: 12px; width: 12px"
                disabled="disabled"
              />
            </v-row>
            <v-row
              v-if="status == 'NOT_STARTED'"
              align="center"
              justify="end"
              class="pr-2"
            >
              <span class="warning--text">
                {{ translations.label_sampling_not_started }}</span
              >
            </v-row>
            <!-- progress bar -->
            <v-row class="pt-2">
              <v-col>
                <v-progress-linear :value="progressBar"></v-progress-linear>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col v-else cols="5" class="pr-5 pl-4">
            <v-row @click="showResults" justify="center" align="center">
              <v-col class="box-rounded">
                <v-row justify="center" align="center">
                  <v-img
                    max-width="16"
                    max-height="19"
                    class="mr-2 mb-2"
                    :src="require('@/assets/img/solenawhite.png')"
                  ></v-img>
                  <p class="sample--tiny-bio white--text mt-2">
                    Capital Biológico
                  </p>
                </v-row>
                <v-row
                  v-if="status == 'MEASURED'"
                  align="center"
                  justify="center"
                  class="pr-1"
                >
                  <v-icon color="secondary" size="15">mdi-check</v-icon>
                  <span class="secondary--text sample--tiny-info mr-1"
                    >Muestreo medido</span
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
  
    <!-- </div> -->
  </template>
  
  <script>
  import moment from "moment";
  import { mapMutations, mapGetters } from "vuex";
  export default {
    data: () => ({
      isAvailableResults: false,
      sendAvailable: false,
      status: "",
      folioAnalysis: "",
      tracingStatus: "",
      checkbox: false,
      code: "",
      fecha: "",
      fecha_result: "",
      qty_photos: 0,
      progressBar: 0,
      sampleSelected: false,
    }),
    props: {
      sample: {
        type: Object,
        required: false,
      },
    },
    created() {
      this.status = this.sample.status;
      this.folioAnalysis = this.sample.folioAnalysis
        ? this.sample.folioAnalysis + " -"
        : "";
  
      if (
        this.sample.tracingStatus == "INITIAL" ||
        this.sample.tracingStatus == "Initial"
      ) {
        this.tracingStatus = this.translations.analysisTypes["INITIAL"];
        if (
          this.sample.status == "MEASURED" ||
          this.sample.status == "VALUATING" ||
          this.sample.status == "VALUATED"
        ) {
          this.isAvailableResults = true;
        }
      } else {
        if (this.sample.status == "MEASURED") {
          this.isAvailableResults = true;
        }
        this.tracingStatus = this.translations.analysisTypes["MONITORING"];
      }
  
      switch (this.sample.sampleType) {
        case "VEGETABLE":
          if (
            this.sample.tracingStatus == "INITIAL" ||
            this.sample.tracingStatus == "Initial"
          ) {
            this.tracingStatus = this.translations.label_valuation;
          } else {
            this.tracingStatus = this.translations.label_measurement;
          }
          break;
        case "COMPOST":
          if (
            this.sample.tracingStatus == "INITIAL" ||
            this.sample.tracingStatus == "Initial"
          ) {
            this.tracingStatus = this.translations.label_valuation;
          } else {
            this.tracingStatus = this.translations.label_measurement;
          }
          break;
        case "PRODUCT":
          if (
            this.sample.tracingStatus == "INITIAL" ||
            this.sample.tracingStatus == "Initial"
          ) {
            this.tracingStatus = this.translations.label_valuation;
          } else {
            this.tracingStatus = this.translations.label_measurement;
          }
          break;
        case "SUBSTRATUM":
          if (
            this.sample.tracingStatus == "INITIAL" ||
            this.sample.tracingStatus == "Initial"
          ) {
            this.tracingStatus = this.translations.label_valuation;
          } else {
            this.tracingStatus = this.translations.label_measurement;
          }
          break;
      }
  
      if (this.status == "NOT_STARTED") {
      } else if (this.status == "IN_PROGRESS") {
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.startDate);
        if (
          this.sample.tracingStatus === "Initial" ||
          this.sample.tracingStatus === "INITIAL"
        ) {
          this.progressBar = 14.29;
        } else {
          this.progressBar = 20;
        }
      } else if (this.status == "VALIDATED") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        if (
          this.sample.tracingStatus === "Initial" ||
          this.sample.tracingStatus === "INITIAL"
        ) {
          this.progressBar = 14.29 * 2;
        } else {
          this.progressBar = 20 * 2;
        }
      } else if (this.status == "SENT") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
      } else if (this.status == "RECEIVED") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        if (
          this.sample.tracingStatus === "Initial" ||
          this.sample.tracingStatus === "INITIAL"
        ) {
          this.progressBar = 14.29 * 3;
        } else {
          this.progressBar = 20 * 3;
        }
      } else if (this.status == "MEASURING") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        this.fecha_result = this.getFormattedResult(this.sample.updatedAt);
        if (
          this.sample.tracingStatus === "Initial" ||
          this.sample.tracingStatus === "INITIAL"
        ) {
          this.progressBar = 14.29 * 4;
        } else {
          this.progressBar = 20 * 4;
        }
      } else if (this.status == "MEASURED") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        this.fecha_result = this.getFormattedResult(this.sample.updatedAt);
        if (
          this.sample.tracingStatus === "Initial" ||
          this.sample.tracingStatus === "INITIAL"
        ) {
          this.progressBar = 14.29 * 5;
        } else {
          this.progressBar = 20 * 5;
        }
      } else if (this.status == "VALUATING") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        this.fecha_result = this.getFormattedResult(this.sample.updatedAt);
        this.progressBar = 14.29 * 5;
      } else if (this.status == "VALUATED") {
        this.code = this.getFormatttedCode(this.sample.container.code);
        this.qty_photos = this.sample.subSamples.length;
        this.fecha = this.getFormatted(this.sample.endDate);
        this.fecha_result = this.getFormattedResult(this.sample.updatedAt);
        this.progressBar = 100;
      }
    },
    methods: {
      getFormatted(date) {
        return moment(date).format("DD-MM-YYYY HH:mm:ss");
      },
      getFormattedResult(date) {
        return moment(date).format("DD-MM-YYYY");
      },
      sampleDetail() {
        this.SET_SAMPLE_SELECTED(this.sample);
        this.$router.push(`/sample-detail/${this.sample._id}`);
      },
      showResults() {
        this.$router.push(`/biological-capital/${this.sample.soilArea}`);
      },
      getFormatttedCode(code) {
        let value = "legacy";
        if (code.includes(value)) {
          return value;
        } else {
          return code;
        }
      },
      showResults() {
        this.$router.push(`/result-list/${this.sample.soilArea._id}`);
      },
      ...mapMutations("samples", ["SET_SAMPLE_SELECTED"]),
      addSample(value) {
        if (value) {
          this.$emit("addSample", this.sample);
        } else {
          this.$emit("removeSample", this.sample);
        }
      },
    },
    computed: {
      ...mapGetters("session", ["currentTranslations"]),
      translations() {
        return this.currentTranslations;
      },
    },
  };
  </script>
  
  <style scoped>
  .box-rounded {
    background: #04c105;
    border-radius: 18px;
    height: 35px;
    width: 100px;
  }
  
  .sample--code {
    font-size: 0.9rem;
  }
  
  .sample--kit {
    font-weight: bold;
    font-size: 0.9rem;
  }
  
  .sample--empty-info {
    font-size: 0.8rem;
  }
  
  .sample--date {
    font-size: 0.9rem;
    color: #818181;
  }
  
  .sample--tiny-info {
    font-size: 0.66rem;
  }
  
  .sample--tiny-bio {
    font-size: 0.72rem;
  }
  </style>
  